import { AggregatedAccommodationType } from '../../aggregating-by-grade/type/types';

export const isBreakSoldOutBasedOnReservedExperiment = (
  isShowReservedBreaksFeatureActive: boolean,
  available: boolean,
  pending: boolean,
) => {
  return isShowReservedBreaksFeatureActive ? !available && !pending : !available || pending;
};

export const isAccommodationTypeSoldOutBasedOnReservedExperiment = (
  isShowReservedBreaksFeatureActive: boolean,
  accommodationType: AggregatedAccommodationType,
) => {
  return isShowReservedBreaksFeatureActive
    ? !accommodationType?.available && !accommodationType?.pending
    : !accommodationType?.available || accommodationType?.pending;
};
